import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { DataLoader } from '../ContractChanges/ContractChangesDataLoader'
import { Form } from './Form'
import { TerminationDisallowedBanner } from './components/TerminationDisallowedBanner/TerminationDisallowedBanner'
import { ContractChangesBanner } from '../ContractChanges/components/ContractChangesBanner/ContractChangesBanner'
import { ContractChangesView } from '../ContractChanges/ContractChangesView/ContractChangesView'
import { resolveContractTerminationTerminology } from '../ContractChanges/utils/resolveContractTerminationTerminology'
import { ContractChangesViewState } from '../ContractChanges/types'
import { ContractChangesSection } from '../../../common/types'

import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'
import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'
import {
  Breakpoint,
  SidebarInfoSection,
  SidebarInfoSectionText,
} from 'components'
import { StyledLink } from 'components/StyledLink/StyledLink'

export const TerminateContract: FC = () => {
  const [view, setView] = React.useState<ContractChangesViewState>('form')
  const { t } = useTranslation(['terminateContract'])
  const { residentChangesPath } = useContractPaths()
  const { contractModification } = useModuleConfig()

  return (
    <DataLoader>
      {(data) => {
        const terminology = resolveContractTerminationTerminology(
          data.contract.contractType
        )

        return (
          <ContractChangesView
            title={t(terminology.viewTitle)}
            banner={
              contractModification &&
              view === 'form' && (
                <ContractChangesBanner
                  contract={data.contract}
                  tenants={data.tenants}
                  otherSection={ContractChangesSection.RESIDENT_CHANGES}
                />
              )
            }
            sidebarInfo={
              <>
                {!contractModification && (
                  <Breakpoint hide tablet desktop>
                    <TerminationDisallowedBanner
                      reason={data.contract.terminationDisallowedReason}
                      contractType={data.contract.contractType}
                    />
                  </Breakpoint>
                )}
                {view === 'form' && (
                  <SidebarInfoSection className="space-y-4">
                    <SidebarInfoSectionText>
                      {t(terminology.viewDescription)}
                    </SidebarInfoSectionText>
                    {contractModification && (
                      <>
                        <SidebarInfoSectionText>
                          {t('terminateContract:view.contractContinuesInfo')}
                        </SidebarInfoSectionText>
                        <SidebarInfoSectionText>
                          {t('terminateContract:view.residentChangesInfo')}
                        </SidebarInfoSectionText>
                        <StyledLink to={residentChangesPath} className="block">
                          {t('terminateContract:links.goToResidentChanges')}
                        </StyledLink>
                      </>
                    )}
                  </SidebarInfoSection>
                )}
              </>
            }
          >
            <Form {...data} view={view} setView={setView} />
          </ContractChangesView>
        )
      }}
    </DataLoader>
  )
}
